module.exports = __webpack_public_path__ + "static/media/Awaiting.fa25d44e.png";